import { render } from "./footer.vue?vue&type=template&id=132512db&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=132512db&lang=scss&scoped=true"

import exportComponent from "/Users/yue/Documents/其他项目/数字转创/official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132512db"]])

export default __exports__